export const type = 'alert.recipients';
